/**
 * Text Ticker
 * Infinite horizontal scroll animation for text carousels
 */

(function() {
  'use strict';

  function initTicker(container) {
    const track = container.querySelector('.text-ticker__track');
    const items = container.querySelector('.text-ticker__items');
    if (!track || !items) return;

    const speed = parseInt(container.dataset.tickerSpeed) || 70;
    const reverse = container.dataset.tickerReverse === 'true';
    const pauseOnHover = container.dataset.tickerPause === 'true';

    // Clone container for seamless loop
    let clone = track.querySelector('.text-ticker__items--clone');

    function calculateAndAnimate() {
      // Use getBoundingClientRect for accurate width
      const itemsWidth = items.getBoundingClientRect().width;

      // Get gap from items container
      const gap = parseInt(getComputedStyle(items).columnGap) || 16;

      if (!itemsWidth) return;

      // Create clone if it doesn't exist
      if (!clone) {
        clone = document.createElement('div');
        clone.className = 'text-ticker__items text-ticker__items--clone';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      // Populate clone with same content
      clone.innerHTML = items.innerHTML;

      // Calculate animation duration based on content width and speed
      const totalWidth = itemsWidth + gap;
      const duration = totalWidth / speed;

      // Set CSS custom properties on track
      track.style.setProperty('--ticker-duration', `${duration}s`);
      track.style.setProperty('--ticker-direction', reverse ? 'reverse' : 'normal');
      track.style.setProperty('--ticker-width', `${totalWidth}px`);
      track.style.setProperty('--ticker-gap', `${gap}px`);
      track.style.setProperty('--ticker-pause-on-hover', pauseOnHover ? 'paused' : 'running');
    }

    // Initial calculation
    calculateAndAnimate();

    // Recalculate on resize
    const resizeObserver = new ResizeObserver(calculateAndAnimate);
    resizeObserver.observe(items);
  }

  function init() {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach(initTicker);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const ticker = e.target.querySelector('[data-ticker]');
    if (ticker) initTicker(ticker);
  });
})();
